var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var defaultConfig = { endpoint: 'photo-ugc' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign(__assign({}, defaultConfig), restOfConfig);
    var factoryInstance = typeof webOrMobileLogger.factory === 'function' ? webOrMobileLogger.factory(config) : webOrMobileLogger;
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
var initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams, context) {
                return _this.bi.log(logParams, context);
            }
        };
        biLoggerClientFactoryInstance.updateDefaults({ src: 65 });
        this.bi = biLoggerClientFactoryInstance.logger({});
    }
    Logger.prototype.createCollection = function (params) {
        return this.bi.log(__assign({ evid: 198, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.collectionCreated = function (params) {
        return this.bi.log(__assign({ evid: 199, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.openWizardCreateCollection = function (params) {
        return this.bi.log(__assign({ evid: 208, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.photoAlbumButtonOnClick = function (params) {
        return this.bi.log(__assign({ evid: 211, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.downloadFilesFromCollection = function (params) {
        return this.bi.log(__assign({ evid: 218, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.clickOnSelectMediaCollection = function (params) {
        return this.bi.log(__assign({ evid: 228, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.addCommentOnAnItemCollection = function (params) {
        return this.bi.log(__assign({ evid: 229, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.clickSaveCollection = function (params) {
        return this.bi.log(__assign({ evid: 232, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.clickOnInviteMemberToCollection = function (params) {
        return this.bi.log(__assign({ evid: 233, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.navigationInCollectionMemberArea = function (params) {
        return this.bi.log(__assign({ evid: 234, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.popupOpened = function (params) {
        return this.bi.log(__assign({ evid: 279, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.dropDownMenuOnPhoto = function (params) {
        return this.bi.log(__assign({ evid: 285, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.albumNameError = function (params) {
        return this.bi.log(__assign({ evid: 294, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.clickButtonInPopup = function (params) {
        return this.bi.log(__assign({ evid: 297, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.albumActions = function (params) {
        return this.bi.log(__assign({ evid: 300, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.gogLoaded = function (params) {
        return this.bi.log(__assign({ evid: 301, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.gogAlbumClick = function (params) {
        return this.bi.log(__assign({ evid: 302, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.photoAlbumCoverLoaded = function (params) {
        return this.bi.log(__assign({ evid: 303, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.proGalleryLoadUou = function (params) {
        return this.bi.log(__assign({ evid: 304, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.migratedLoveData = function (params) {
        return this.bi.log(__assign({ evid: 305, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.artStorePerformanceUou = function (params) {
        return this.bi.log(__assign({ evid: 306, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.photoAlbumGalleryLoaded = function (params) {
        return this.bi.log(__assign({ evid: 307, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.share = function (params) {
        return this.bi.log(__assign({ evid: 500, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.love = function (params) {
        return this.bi.log(__assign({ evid: 501, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.download = function (params) {
        return this.bi.log(__assign({ evid: 502, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.info = function (params) {
        return this.bi.log(__assign({ evid: 503, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.expand = function (params) {
        return this.bi.log(__assign({ evid: 504, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.galleryRendered = function (params) {
        return this.bi.log(__assign({ evid: 508, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.proGalleryErrorUou = function (params) {
        return this.bi.log(__assign({ evid: 512, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.galleryClickOnItem = function (params) {
        return this.bi.log(__assign({ evid: 520, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.galleryItemExpanded = function (params) {
        return this.bi.log(__assign({ evid: 521, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.selectPhoto = function (params) {
        return this.bi.log(__assign({ evid: 600, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.shareGroup = function (params) {
        return this.bi.log(__assign({ evid: 601, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.landAfterShare = function (params) {
        return this.bi.log(__assign({ evid: 602, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.buyBuyNowClick = function (params) {
        return this.bi.log(__assign({ evid: 800, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.buySelectLicense = function (params) {
        return this.bi.log(__assign({ evid: 801, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.providerBuyAddToCart = function (params) {
        return this.bi.log(__assign({ evid: 802, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.providerCartCheckout = function (params) {
        return this.bi.log(__assign({ evid: 803, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.downloadImage = function (params) {
        return this.bi.log(__assign({ evid: 805, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    Logger.prototype.proGalleryClickOnCustomButton = function (params) {
        return this.bi.log(__assign({ evid: 807, src: 65 }, params), { endpoint: 'photo-ugc' });
    };
    return Logger;
}());
export { Logger };
export default init;
export function getLoggerConf() {
    return {
        src: 65,
        endpoint: 'photo-ugc'
    };
}
//# sourceMappingURL=index.js.map